import React, { Component } from 'react'

import {Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField} from '@material-ui/core'

/**
 * Диалог ввода имени для восстановления пароля.
 * 
 * onRestorePasswordClick(name)
 * onCancelClick()
 */

class RestorePasswordDialog extends Component {

	state = {
		name: "",
	}

	render() {

		return <Dialog open scroll = "body">
			<DialogTitle>Восстановить пароль</DialogTitle>
			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				<TextField
					value = {this.state.name}
					label = "Имя пользователя"
					margin = "normal"
					onChange = {e => {this.setState({name: e.target.value})}}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={
						e => {
							e.preventDefault()
							if (typeof this.props.onRestorePasswordClick === "function") {
								this.props.onRestorePasswordClick(this.state.name)
							}
						}
					}
				>Восстановить</Button>
				<Button
					onClick={
						e => {
							e.preventDefault()
							if (typeof this.props.onCancelClick === "function") {
								this.props.onCancelClick()
							}
						}
					}
				>Отмена</Button>
			</DialogActions>
		</Dialog>
	}

}

export default RestorePasswordDialog
